<template>
  <template v-if="isImage">
    <q-img
      v-if="isLogo"
      class="cursor-pointer"
      :src="getLogo ? getLogo : logo"
      :fit="fit"
      :width="width"
      :height="height"
      :class="className"
      @click="click"
      :alt="getCompanyName()"
    />
    <q-img
      v-else
      class="cursor-pointer"
      :src="getImage ? getImage : icon"
      :fit="fit"
      :width="width"
      :height="height"
      :class="className"
      @click="click"
      :alt="getCompanyName()"
    />
  </template>
  <template v-else>
    <span class="cursor-pointer" @click="click">{{ getCompanyName() }}</span>
  </template>

  <!-- appIcon.svg -->
</template>

<script setup>
import { useCommonStore } from "src/stores/common-store";
import { getCompanyName } from "src/utils/commonFunction";
import { computed } from "vue";

const props = defineProps({
  logo: {
    type: String,
    default: "logo.svg",
  },
  icon: {
    type: String,
    default: "accountLogo/app-icon.png",
  },
  fit: {
    type: String,
    default: "contain",
  },
  width: {
    type: String,
    default: "60px",
  },
  height: {
    type: String,
    default: "60px",
  },
  className: {
    type: String,
    default: "",
  },
  isImage: {
    type: Boolean,
    default: true,
  },
  isLogo: {
    type: Boolean,
    default: false,
  },
  click: {
    type: Function,
    default: null,
  },
});

const commonStore = useCommonStore();

const getImage = computed(() => {
  var tmp = "";
  if (
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("app_icon") &&
    commonStore.storeDetails.app_icon &&
    commonStore.storeDetails.app_icon.length
  ) {
    tmp = commonStore.storeDetails.app_icon;
  }
  return tmp;
});

const getLogo = computed(() => {
  var tmp = "";
  if (
    commonStore.storeDetails &&
    Object.keys(commonStore.storeDetails).length &&
    commonStore.storeDetails.hasOwnProperty("app_logo") &&
    commonStore.storeDetails.app_logo &&
    commonStore.storeDetails.app_logo.length
  ) {
    tmp = commonStore.storeDetails.app_logo;
  }
  return tmp;
});
</script>
